module.exports = __webpack_public_path__ + "img/arena-1540.040b7fb5.png";